module.exports = __webpack_public_path__ + "static/img/record-xuanchuan.65e0caae.jpg";